module.exports = __webpack_public_path__ + "img/p2.741b6f18.png";